// Font Families
export const fontFamilySansSerif = '"Packup", "Open Sans", sans-serif';
export const fontFamilySerif = 'Georgia, serif';
export const fontFamilyMonospace = 'Consolas, Liberation Mono, Menlo, Courier, monospace';
export const headingsFontFamily = fontFamilySansSerif;

// Font Sizes
// https://www.codementor.io/@ricardozea/100-responsive-typography-system-using-a-modular-scale-s5rhft58g
export const fontSizeMega = '2.197em';
export const fontSizeH1 = '1.912em';
export const fontSizeH2 = '1.616em';
export const fontSizeH3 = '1.471em';
export const fontSizeH4 = '1.3em';
export const fontSizeH5 = '1.243em';
export const fontSizeH6 = '1.132em';

export const fontSizeBase = '1em';
export const fontSizeSmall = '.85em';
export const fontSizeXSmall = '.75em';

export const lineHeightBase = '1.5';
export const lineHeightSmall = '1.1';
